<template>
  <v-navigation-drawer
    v-if="authenticated"
    v-model="drawer"
    floating
    app
    color="blue-grey lighten-5"
  >
    <div class="evoting-header pt-4 px-2 pb-2">
      <!-- <v-toolbar-title class="mb-3">
          <h2>E-Support</h2>
        </v-toolbar-title> -->

      <div class="d-flex align-center justify-center mt-3 mb-5">
        <v-img
          class="shrink mr-2"
          contain
          src="/favicon.png"
          transition="scale-transition"
          width="40"
        />
        <h2>E-Voting</h2>
      </div>
    </div>

    <v-list dense nav>
      <v-list-item-group active-class="brown--text text--accent-4">
        <div v-if="authenticated">
          <v-list-item class="mb-1" to="/">
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>

          <v-list-item class="mb-1" to="/setup">
            <v-list-item-icon>
              <v-icon>mdi-folder-plus-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Setup Election</v-list-item-title>
          </v-list-item>

          <v-list-item class="mb-1" to="/elections">
            <v-list-item-icon>
              <v-icon>mdi-vote-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Elections</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item dense class="mb-1" to="/pinned">
            <v-list-item-icon>
              <v-icon>mdi-pin-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Pinned </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip x-small class="grey--text text--lighten-2">{{
                pinned.length
              }}</v-chip>
            </v-list-item-action>
          </v-list-item> -->
        </div>

        <div v-if="administrator">
          <v-divider class="my-3"></v-divider>
          <v-list-item class="mb-1" to="/staff">
            <v-list-item-icon>
              <v-icon>mdi-account-group-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Staff</v-list-item-title>
          </v-list-item>
        </div>
      </v-list-item-group>

      <v-list-group
        prepend-icon="mdi-cog-outline"
        no-action
        v-if="administrator"
      >
        <template v-slot:activator>
          <v-list-item-title>Settings</v-list-item-title>
        </template>

        <v-list-item class="mb-1" @click.prevent="openAssociationsDialog">
          <v-list-item-content>
            <v-list-item-title>Associations & Groups</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item class="mb-1" to="/notifications">
          <v-list-item-content>
            <v-list-item-title>Action Log</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list-group>
    </v-list>

    <template v-slot:append>
      <div class="pa-2">
        <v-btn text block @click="logoutUser">
          Logout <v-icon class="ml-2" small>mdi-lock-outline</v-icon>
        </v-btn>
      </div>
    </template>

    <Associations />
  </v-navigation-drawer>
</template>

<script>
import Associations from "../../dialogs/Associations.vue";

export default {
  name: "Drawer",

  props: ["show"],

  components: {
    Associations,
  },

  watch: {
    show(value) {
      this.drawer = value;
    },
  },

  data: () => ({
    drawer: false,
    authenticated: true,
    administrator: true,

    pinned: [1, 3],
  }),

  methods: {
    logoutUser() {
      this.$bus.$emit("logout");
    },

    openAssociationsDialog() {
      this.$bus.$emit("settings.associations");
    },
  },
};
</script>


<style lang="scss" scoped>
.evoting-header {
  background-color: #eff8f2;
  background-color: #1c1a7e;
  background-color: #7e1a1a;
  // border-right: 1px solid #8eb49c;

  h2 {
    font-size: 1.75em;
    color: #ffffff;
  }
}
</style>